import { IconArrowRight } from "@tabler/icons-react";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./sms.module.scss";

type Props = { title: string; back?: string; actions?: ReactNode };

// Goes back in history when there is one, otherwise to `back` (a page opened from a link or after refresh).
export default function PageHeader({ title, back = "/dashboard/marketing", actions }: Props) {
  const navigate = useNavigate();
  const goBack = () => (window.history.state?.idx > 0 ? navigate(-1) : navigate(back, { replace: true }));
  return (
    <header className={classes.header}>
      <button type="button" className={classes.backButton} aria-label="بازگشت" onClick={goBack}>
        <IconArrowRight size={22} stroke={1.8} />
      </button>
      <h1 className={classes.headerTitle}>{title}</h1>
      {actions}
    </header>
  );
}
